import { useState, Suspense, lazy, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react'

const saleModules = {
  ...import.meta.glob('./sales/**/*.{jsx,tsx}'),
  ...import.meta.glob('./interactions/**/*.{jsx,tsx}'),
}

const SaleElement = ({ vaType, path, isBlockedIfMcpCreated }) => {
  const { t } = useTranslation()
  const [Sale, setSale] = useState(null)

  useEffect(() => {
    const loader =
      saleModules[`./${vaType}/${path}/${path}.tsx`] ??
      saleModules[`./${vaType}/${path}/${path}.jsx`]

    if (!loader) {
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('Sale element not found'), { extra: { vaType, path } })
      }
      return
    }

    setSale(lazy(loader))
  }, [path, vaType])

  if (!Sale) {
    return ''
  }

  if (isBlockedIfMcpCreated) {
    return <p> {t('additionalSales:common.script_mcp_already_created')} </p>
  }

  return (
    <Suspense fallback={<div>{t('common:loading')}</div>}>
      <Sale />
    </Suspense>
  )
}

export default SaleElement
